"use client";

import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import { ResponsiveCommandSelect } from "@/components/ui/responsive-select";
import type { CommunicationFormValues } from "./communicationFormSchema";

interface TitleAndTypeProps {
  control: Control<CommunicationFormValues>;
  typeOptions: Array<{ value: string; label: string }>;
  isLoadingTypes: boolean;
  isSubmitting: boolean;
}

export function TitleAndTypeFields({
  control,
  typeOptions,
  isLoadingTypes,
  isSubmitting,
}: TitleAndTypeProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Title</FormLabel>
            <FormControl>
              <Input
                placeholder="Communication subject or title"
                {...field}
                disabled={isSubmitting}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="type_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Type</FormLabel>
            <FormControl>
              <ResponsiveCommandSelect
                value={field.value}
                onValueChange={field.onChange}
                options={typeOptions}
                placeholder={isLoadingTypes ? "Loading..." : "Select communication type"}
                disabled={isSubmitting || isLoadingTypes}
                title="Communication Type"
                description="Choose the type of communication"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
